import './Heading2.scss';

const Heading2 = (props) => {
    return <div className="timeline-dot">
        <h1 id={props.id} className="iam-naveen">{props.children}</h1>
    </div>
}

export default Heading2;
